



































import {
    defineComponent,
    PropType,
} from '@vue/composition-api';

import { LicencePreferencesPayload } from '@core/services/user/_private/Types';
import {
    LicencePreferences,
    BgcLicence,
} from '@accountFederation/modules/licencePreferences/types';

import LicenceSwitch from './LicenceSwitch.vue';
import { getAccountConfig } from '@accountFederation/config/accountConfig';

export default defineComponent({
    name: 'LicencePreferences',
    props: {
        licences: {
            type: Object as PropType<LicencePreferences>,
            required: true,
        },
        hasLicencesLink: {
            type: Boolean,
            required: false,
            default: false,
        },
        smallText: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: [
        'change',
    ],
    setup(props, { emit }) {
        const mappedLicences = Object.entries(props.licences).map(([licenceName, licenceState]) => {
            return {
                ...licenceState,
                accepted: licenceState.accepted ?? false,
                name: licenceName as BgcLicence,
                disabledLabel: `pam.preferencesModal.${licenceName}.disabled`,
                label: `pam.preferencesModal.${licenceName}.label`,
            };
        });

        function getLicencePreferencesPayload(): LicencePreferencesPayload {
            return {
                licences: mappedLicences.reduce((payload, licence) => {
                    // eslint-disable-next-line no-param-reassign
                    payload[licence.name] = licence.accepted ?? false;
                    return payload;
                }, {} as Record<BgcLicence, boolean>),
            };
        }

        function emitChangeEvent(): void {
            emit('change', getLicencePreferencesPayload());
        }

        const areSitesSplitByLicence = getAccountConfig().areSitesSplitByLicence;
        const currentLicence = mappedLicences[0].name;

        emitChangeEvent();

        return {
            mappedLicences,
            emitChangeEvent,
            textStyle: props.smallText ? 'licence-intro--small' : '',
            description: areSitesSplitByLicence ? `pam.licencePreferences.licenceDescription.${currentLicence}` : 'pam.licencePreferences.description',
            checkLicenceLabel: areSitesSplitByLicence ? 'pam.licencePreferences.checkLicence' : 'pam.licencePreferences.checkLicences',
        };
    },
    components: {
        LicenceSwitch,
    },
});
